export default "__VITE_ASSET__CrDq4Gcy__"